import { useRef } from 'react';

import type { ItemRef } from '../types/itemRef.types';

type ReturnType = {
  getRef: (id: string) => ItemRef['ref'] | null;
  refs: ItemRef[];
};

export function useItemRefs(): ReturnType {
  const refs = [
    {
      id: 'mainSettings',
      ref: useRef(null)
    },
    {
      id: 'mediaChannel',
      ref: useRef(null)
    },
    {
      id: 'ioSettings',
      ref: useRef(null)
    },
    {
      id: 'advertisingPlatform',
      ref: useRef(null)
    },
    {
      id: 'campaignMarketplace',
      ref: useRef(null)
    },
    {
      id: 'flightSettings',
      ref: useRef(null)
    },
    {
      id: 'schedulingDistribution',
      ref: useRef(null)
    },
    {
      id: 'budgetAndGoals',
      ref: useRef(null)
    },
    {
      id: 'pricingModel',
      ref: useRef(null)
    },
    {
      id: 'locations',
      ref: useRef(null)
    },
    {
      id: 'contextTargeting',
      ref: useRef(null)
    },
    {
      id: 'locationQualityIndexes',
      ref: useRef(null)
    },
    {
      id: 'supplySource',
      ref: useRef(null)
    },
    {
      id: 'appSiteCategories',
      ref: useRef(null)
    },
    {
      id: 'appSiteChannel',
      ref: useRef(null)
    },
    {
      id: 'mobileDevicesConnectivity',
      ref: useRef(null)
    },
    {
      id: 'demography',
      ref: useRef(null)
    },
    {
      id: 'retargeting',
      ref: useRef(null)
    },
    {
      id: 'audienceTargeting',
      ref: useRef(null)
    },
    {
      id: 'mediaQualityAssurance',
      ref: useRef(null)
    },
    {
      id: 'appMarketplace',
      ref: useRef(null)
    },
    {
      id: 'temperatureAndWeather',
      ref: useRef(null)
    },
    {
      id: 'deviceTargeting',
      ref: useRef(null)
    },
    {
      id: 'contextualBidding',
      ref: useRef(null)
    },
    {
      id: 'contentCategories',
      ref: useRef(null)
    },
    {
      id: 'adCreatives',
      ref: useRef(null)
    },
    {
      id: 'conversionTracking',
      ref: useRef(null)
    },
    {
      id: 'contextualSettings',
      ref: useRef(null)
    },
    {
      id: 'contextualMacros',
      ref: useRef(null)
    },
    {
      id: 'sonataMORE',
      ref: useRef(null)
    }
  ];

  const getRef = (id: string): ItemRef['ref'] | null => {
    return refs.find(ir => ir.id === id)?.ref || null;
  };

  return {
    getRef,
    refs
  };
}
